import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { SegmentInformationDto } from "../dto/segment.information.dto";
import {PropertyAddressDto} from "../dto/property.address.dto";

@Injectable({
    providedIn: 'root'
})
export class MapsSubject {
    private mapSubject: BehaviorSubject<PropertyAddressDto | null> = new BehaviorSubject<PropertyAddressDto | null>(null);
    public mapDetail$: Observable<PropertyAddressDto | null> = this.mapSubject.asObservable();

    /**
     * Actualiza el map seleccionado en el BehaviorSubject.
     * @param map El map seleccionado por el usuario.
     */
    public saveMap(map: PropertyAddressDto): void {
        if (this.mapSubject.value !== map) {
            this.mapSubject.next(map);
            console.log('Map seleccionado:', map);
        }
    }

    /**
     * Obtiene el map seleccionado actualmente.
     * @returns El map seleccionado actual.
     */
    public getSelectedMap(): PropertyAddressDto | null {
        return this.mapSubject.value;
    }
}
